import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

/**
 * FAQ accordion. Answers are grounded in what the platform actually does —
 * no invented policies or claims.
 */
const FAQ_KEYS = [
  'cost',
  'whoIsItFor',
  'submitPaper',
  'fileFormats',
  'peerReview',
  'cameraReady',
  'emails',
  'announcements',
  'languages'
];

const FAQSection = () => {
  const { t } = useTranslation('conferences');
  const [openKey, setOpenKey] = useState('cost');

  return (
    <section className="bg-card border-y border-border py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h2 className="font-heading font-bold text-foreground text-[26px] sm:text-[32px] leading-[1.15]">
            {t('landing.faq.title', 'Questions, answered.')}
          </h2>
        </div>

        <dl className="divide-y divide-border border-t border-b border-border">
          {FAQ_KEYS?.map((key) => {
            const isOpen = openKey === key;
            return (
              <div key={key}>
                <dt>
                  <button
                    onClick={() => setOpenKey(isOpen ? null : key)}
                    aria-expanded={isOpen}
                    className="w-full text-start py-5 flex items-center justify-between gap-4 group focus-ring"
                  >
                    <span className="text-[15px] font-semibold text-foreground group-hover:text-primary transition-colors">
                      {t(`landing.faq.items.${key}.q`)}
                    </span>
                    <Icon
                      name={isOpen ? 'Minus' : 'Plus'}
                      size={16}
                      className="flex-shrink-0 text-muted-foreground"
                    />
                  </button>
                </dt>
                {isOpen && (
                  <dd className="pb-5 -mt-1 font-academic text-[16px] leading-[1.7] text-muted-foreground max-w-2xl">
                    {t(`landing.faq.items.${key}.a`)}
                  </dd>
                )}
              </div>
            );
          })}
        </dl>
      </div>
    </section>
  );
};

export default FAQSection;
